import {
  PURCHASE_ORDER_ALL,
  PURCHASE_ORDER_GET,
  PURCHASE_ORDER_DEL,
  PURCHASE_ORDER_PUT,
  PURCHASE_ORDER_POST,
  PURCHASE_ORDER_LOADING,
  PURCHASE_ORDER_ERROR,
} from '../../actions/types';

const initialState = {
  purchaseOrder: null,
  isLoading: true,
  isCompleted: true,
};
// eslint-disable-next-line func-names
export default function (state = initialState, action) {
  switch (action.type) {
    case PURCHASE_ORDER_LOADING:
      return { isLoading: true, isCompleted: true };
    case PURCHASE_ORDER_ERROR:
      return { isLoading: false, isCompleted: false, ...action.payload };
    case PURCHASE_ORDER_ALL:
      return {
        ...action.payload,
        isLoading: false,
        isCompleted: true,
      };
    case PURCHASE_ORDER_GET:
      return {
        ...action.payload,
        isLoading: false,
        isCompleted: true,
      };
    case PURCHASE_ORDER_POST:
      return { isLoading: false, isCompleted: true };
    case PURCHASE_ORDER_PUT:
      return { isLoading: false, isCompleted: true };
    case PURCHASE_ORDER_DEL:
      return { isLoading: false, isCompleted: true };
    default:
      return state;
  }
}
